export class WorkStatusRequestDTO {
    constructor({
        id=0,
        userId='',
        userName='',
        email='',
        organizationId='',
        dateFrom=null,
        dateTo=null,
        dayStatus=0,
        requestStatus=0,
        holidayDays=null,
        comment=null,
    } = {}) {
        this.id = id;
        this.userId = userId;
        this.userName = userName;
        this.organizationId = organizationId;
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.dayStatus = dayStatus;
        this.requestStatus = requestStatus;
        this.email = email;
        this.holidayDays = holidayDays;
        this.comment = comment;
    }

}
export default WorkStatusRequestDTO;